import { Paper, Typography } from "@mui/material"
import ProcurementContainer from "../../procurement/containers/ProcurementContainer"
import PendingReviewPaymentRequisitionsList from "../lists/pendingReviewPaymentRequisitionsList"
import React from "react";

const PendingReviewPage: React.FC = () => {
  return (
    <ProcurementContainer>
      <Typography variant='h1' gutterBottom style={{ fontWeight: 'bold', color: '#123456' }}>
        Pending Review
      </Typography>
      <Paper sx={{my: 5}}>
        <PendingReviewPaymentRequisitionsList />
      </Paper>
    </ProcurementContainer>
  )
}

export default PendingReviewPage
